"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSaveUserParamsAllowed = void 0;
const country_1 = require("../enums/country");
const isSaveUserParamsAllowed = (isSubmission, country) => {
    if (isSubmission) {
        // If the command is being submitted, we allow saving user params
        return true;
    }
    const countryDoNotAllowSaveUserParams = [
        country_1.OrganizationCountry.Canada,
        country_1.OrganizationCountry.GreatBritain,
        country_1.OrganizationCountry.Australia,
        country_1.OrganizationCountry.Ireland,
        country_1.OrganizationCountry.Germany,
    ].includes(country);
    return !countryDoNotAllowSaveUserParams;
};
exports.isSaveUserParamsAllowed = isSaveUserParamsAllowed;
